import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { EventTrackerService, PlaybackService } from '@splixer/player';
import { BreadcrumbItem, BreadcrumbToolbarController } from '@hidat/ng-common';

@Component({
  selector: 'kexp-breadcrumbs',
  templateUrl: 'breadcrumbs.component.html',
  standalone: true,
  imports: [
    RouterLink,
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent extends BreadcrumbToolbarController {
  protected playbackService = inject(PlaybackService);
  protected eventTracker = inject(EventTrackerService);

  protected rightButton = signal<BreadcrumbItem | undefined>(undefined);
  protected libraryRoot = 'library';
  protected playlistRoot = 'np';
  protected libraryRootBreadcrumb: BreadcrumbItem;
  protected eventSource = 'breadcrumb';

  constructor() {
    super();
    this.hideHomeLink = true;
    this.libraryRootBreadcrumb = {
      label: 'Library',
      path: this.libraryRoot,
      routerLink: [this.libraryRoot],
      key: this.libraryRoot,
      lastItem: true,
      klasses: ['font-semibold'],
    }

    this.rightButton.set({
      label: 'Playlist',
      path: this.playlistRoot,
      routerLink: [this.playlistRoot],
      key: this.playlistRoot,
      lastItem: false,
      klasses: ['font-semibold'],
    })

  }


  protected override updateCrumbsAndToolbar() {
    const currentRoute = this.route.root;
    const crumbs = this.buildBreadcrumbs(currentRoute);
    if (crumbs) {
      if (crumbs[0].path === this.libraryRoot) {
        this.breadcrumbs.set(crumbs);
      } else {
        this.breadcrumbs.set([this.libraryRootBreadcrumb])
      }
    }
    this.updateToolbar(currentRoute);
  }

  protected showRightButton = computed(() => {
    return this.playbackService.firstPlayStarted();
  })

  protected trackBreadcrumbClick = (label:string) => {
    this.eventTracker.trackEventWithSource('crumb_click', this.eventSource, {item_name: label})
  }
  protected trackPlaylistClick = () => {
    this.eventTracker.showPlaylist(this.eventSource)
  }

  /*
  protected override updateToolbar(route: ActivatedRoute): boolean {
    if (this.playbackService.firstPlayStarted()) {
      this.rightButton.set({
        label: 'Playlist',
        path: this.playlistRoot,
        routerLink: [this.playlistRoot],
        key: this.playlistRoot,
        lastItem: false,
        klasses: ['font-semibold'],
      })
    }
    return true;
  }*/
}
